export default {
  creditCardFees: {
    name: "Credit & Debit Card",
    value: 5
  },
  cashFees: {
    name: "Cash through AMAN",
    value: 0
  },
  VatFees: {
    name: "Vat",
    value: 0.14
  }
  ,
  AdvanceSalesFees: {
    name: "AdvanceSalesFees",
    value: 0.03
  }
};
